import { Box, Group, Loader, Stack, Text } from '@mantine/core';
import RouteAppShell from '@/common/components/app-shell/RouteAppShell.tsx';

export default function LoaderAppShell({ text }: { text?: string }) {
  return (
    <RouteAppShell>
      <Box p="sm">
        <Group justify="center">
          <Stack align="center">
            <Loader size="sm" />
            <Text>{text ?? 'Loading...'}</Text>
          </Stack>
        </Group>
      </Box>
    </RouteAppShell>
  );
}
